import { ArgTypes } from '../utils/ArgValidation';
import { $TSFixMe } from '../utils/typescript';
import { getModelHelpers, InferConstructorArgTypes, InferReadTypes } from './Model';
import PairCommentId from './PairCommentId';
import PairId from './PairId';

/**
 * Object used to create a comment on a record pair
 */
export class PairComment extends getModelHelpers({
  entityId1: { type: ArgTypes.string },
  entityId2: { type: ArgTypes.string },
  username: { type: ArgTypes.string },
  message: { type: ArgTypes.string },
  createdAt: { type: ArgTypes.timestamp },
  modifiedAt: { type: ArgTypes.timestamp },
}, 'PairComment')(({ RecordClass, typesAndDefaults, checkConstructorArgs, checkSetArgs }) => {
  type ConstructorArgTypes = InferConstructorArgTypes<typeof typesAndDefaults>;
  type ReadTypes = InferReadTypes<typeof typesAndDefaults>;
  return class PairCommentRecord extends RecordClass {
    constructor(args: ConstructorArgTypes) {
      checkConstructorArgs(args);
      const { entityId1, entityId2, username, createdAt, modifiedAt, message } = args;
      const swap = entityId1 > entityId2;
      const argsInCorrectOrder = {
        entityId1: swap ? entityId2 : entityId1,
        entityId2: swap ? entityId1 : entityId2,
        username,
        createdAt,
        modifiedAt,
        message,
      };
      super(argsInCorrectOrder);
    }
    set<T extends keyof ReadTypes>(name: T, value: ReadTypes[T]) {
      checkSetArgs(name, value);
      return super.set(name, value);
    }
  };
}) {
  static get argType() { return ArgTypes.instanceOf(this); }

  toPairCommentId() {
    const { entityId1, entityId2, username, createdAt } = this;
    return new PairCommentId({ entityId1, entityId2, username, createdAt });
  }


  static fromJSON(json: $TSFixMe) {
    const { entityId1, entityId2, username, createdAt, modifiedAt, message } = json;
    return new PairComment({
      entityId1,
      entityId2,
      username,
      createdAt,
      modifiedAt,
      message,
    });
  }

  static fromPair(pair: $TSFixMe, message: string, username: string) {
    const { entityId1, entityId2 } = pair;
    const timestamp = Math.floor(Date.now() / 1000);
    return new PairComment({
      entityId1,
      entityId2,
      username,
      createdAt: timestamp,
      modifiedAt: timestamp,
      message,
    });
  }

  static fromExistingComment(comment: $TSFixMe, newMessage: string) {
    const { entityId1, entityId2, username, createdAt } = comment;
    const timestamp = Math.floor(Date.now() / 1000);
    return new PairComment({
      entityId1,
      entityId2,
      username,
      createdAt,
      modifiedAt: timestamp,
      message: newMessage,
    });
  }

  toPairId() {
    const { entityId1, entityId2 } = this;
    return new PairId({
      entityId1,
      entityId2,
    });
  }
}

export default PairComment;
